import Vue from 'vue'
import database from './database'
// DON'T IMPORT STORE HERE TO PREVENT CIRCULAR DEPENDENCIES

export const EventBus = new Vue()

export const GlobalEvents = {
    ROUND_FINISHED: 'round_finished',
    TURN_IN_FINISHED: 'turninfinished',
    CLOSE_OVERLAY: 'close_overlay'
}

EventBus.$on(GlobalEvents.ROUND_FINISHED, () => {
    try {
        database.metadata.getMetadata()
    } catch (error) {
        console.error(error)
    }
})
